exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".col-sm-12[_v-176e7160]{padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-176e7160&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Banner.vue
// module id = 406
// module chunks = 0